import { render } from "./KryptonHelpButton.vue?vue&type=template&id=4a9aa1b4&lang=pug"
import script from "./KryptonHelpButton.vue?vue&type=script&lang=js"
export * from "./KryptonHelpButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__